<template>
    <div>
        <h2 class="primary--text">{{ title }}</h2>
        <v-chip-group v-model="selectedFilters" multiple class="d-flex flex-wrap align-center" @change="onFilterChange">
            <template v-if="title === 'Activity'">
                <v-chip v-for="filter in availableFilters" :key="filter.name" :value="filter.name" filter outlined
                    class="ma-1">
                    {{ filter.name }}
                </v-chip>
            </template>
        </v-chip-group>
        <v-divider class="primary"></v-divider>
        <div class="ma-2"></div>
        <slot></slot>

    </div>
</template>

<script>
export default {
    data: () => ({
        selectedFilters: [],
        availableFilters: [
            { name: 'AutoDiagJob' },
            { name: 'GetReportJob' },
            { name: 'SetOrGetParamJob' },
            { name: 'AppUpdateJob' },
            { name: 'NoSleepJob' },
            { name: 'GetDiagJob' },
            { name: 'SetOrGetPropertiesJob' }
        ]
    }),

    props: {
        title: String,
        test: Array
    },
    methods: {
        onFilterChange(filters) {
            this.$emit("filterJobs", filters)
        }
    }
}
</script>